import { FaEye } from "react-icons/fa";
import { ROUTES } from "../../../constants/routes-path";
import { PERMISSIONS } from "constants/permission";

export const TrafficViolationGeneralActions = (t, navigate) => [
    {
        label: t("traffic-violation.list.table.actions.details"),
        permissions: [PERMISSIONS.VIOLATION_QUERY],
        icon: <FaEye />,
        visible: () => true,
        onClick: ({ original }) => {
            navigate(ROUTES.trafficViolationsDetailsPath.replace(":id", original?.id));
        },
    },
];
